import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { filter, firstValueFrom } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isInitialized()) {
    await firstValueFrom(toObservable(authService.isInitialized).pipe(filter(i => i)));
  }

  if (authService.isLoggedIn() && !authService.userProfile()) {
    await firstValueFrom(
      toObservable(authService.userProfile).pipe(filter(p => !!p))
    );
  }

  if (authService.isLoggedIn() && authService.userProfile()) {
    return true;
  }

  return router.parseUrl('/aguai-2026/login');
};
